import { useEffect, useState } from 'react';

// Auth panel view state, kept in sync with the `?view=` URL slug so
// refresh / browser-back / shared links land on the same panel the
// user sees. Internal enum values (`login` / `register` / `reset`)
// are isolated from the canonical URL slugs (`register`,
// `reset-password`, none-for-login) via the maps below — change a
// slug here, no caller knows.

export const VIEW_LOGIN = 'login';
export const VIEW_REGISTER = 'register';
export const VIEW_RESET = 'reset';

const TO_SLUG = {
    [VIEW_REGISTER]: 'register',
    [VIEW_RESET]: 'reset-password',
};

const FROM_SLUG = {
    register: VIEW_REGISTER,
    'reset-password': VIEW_RESET,
    reset: VIEW_RESET, // tolerant alias for legacy callers
};

const readView = () => {
    const slug = new URLSearchParams(window.location.search).get('view');
    return FROM_SLUG[slug] || VIEW_LOGIN;
};

const writeView = (view) => {
    const params = new URLSearchParams(window.location.search);
    const slug = TO_SLUG[view];
    if (slug) params.set('view', slug);
    else params.delete('view');
    const q = params.toString();
    const next = window.location.pathname + (q ? `?${q}` : '') + window.location.hash;
    if (next !== window.location.pathname + window.location.search + window.location.hash) {
        window.history.pushState({}, '', next);
    }
};

export default function useAuthView() {
    const [view, setView] = useState(readView);

    useEffect(() => {
        const onPop = () => setView(readView());
        window.addEventListener('popstate', onPop);
        return () => window.removeEventListener('popstate', onPop);
    }, []);

    const navigate = (next) => {
        writeView(next);
        setView(next);
    };

    return [view, navigate];
}
